import { render } from "./ChatIndexPage.vue?vue&type=template&id=2345c5c3"
import script from "./ChatIndexPage.vue?vue&type=script&lang=ts"
export * from "./ChatIndexPage.vue?vue&type=script&lang=ts"

import "./ChatIndexPage.vue?vue&type=style&index=0&id=2345c5c3&lang=less"
script.render = render

export default script